export default __webpack_public_path__ + "static/media/movieDB.9323d01b.jpg";